import React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  copyrightBackdrop: {
    height: '100%',
    paddingTop: '15px',
    backgroundColor: theme.palette.nile.bermudaBlue,
    opacity: 0.75,
    transition: theme.transitions.create('opacity'),
    color: 'white',
  },
}));

export default function Copyright() {
  const classes = useStyles();
  return (
    <Typography
      variant="body2"
      align="center"
      className={classes.copyrightBackdrop}
    >
      Copyright © &nbsp;
      <Link color="inherit" href="https://nile-global.cloud">
        Nile Global Inc.
      </Link>
      {` ${new Date().getFullYear()}`}
    </Typography>
  );
}
